export enum MovieQueryKey {
    MovieDetails = "movie-details"
}
